import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { AddNewAccountComponent } from '../add-new-account.component';
import { MatInputModule } from "@angular/material/input";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-top-up-buffer-modal",
  templateUrl: "./top-up-buffer-modal.component.html",
  styleUrls: ["./top-up-buffer-modal.component.scss"],
  imports: [
    MatInputModule,
    TranslateModule,
    MatDialogModule
  ],
  standalone: true
})
export class TopUpBufferModalComponent  {
  constructor(public dialogRef: MatDialogRef<AddNewAccountComponent>) {}


}
